import { format } from 'date-fns-tz';
import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import {autoinject, bind, Enums, inject, NothingHere, TableHeadOptions} from 'Mri.Web.Common';
import * as React from 'react';
import { BsCardHeading } from '@react-icons/all-files/bs/BsCardHeading';
import { RouteComponentProps } from 'react-router';
import { AppStore } from '../../Core/AppStore';
import { DisplaysStore } from '../DisplaysStore';

export interface IDisplayAlertLogParams {
    serialNumber: string;
}
export interface IDisplayAlertLogProps extends RouteComponentProps<IDisplayAlertLogParams> {}

@autoinject
@observer
export class DisplayWarrantyAlertLog extends React.Component<IDisplayAlertLogProps, any> {
    @action
    public async componentDidMount() {
        this.loading = true;

        try {
            await this.displaysStore.loadWarrantyAlertLogsAsync(this.props.match.params.serialNumber);
        } catch (e: any) {
            this.appStore.setError(e);
        } finally {
            this.loading = false;
        }
    }

    public render() {
        return (
            <div>
                <div>
                    <table className="table table-sm">
                        <thead>
                            <tr>
                                <th scope="col">Event</th>
                                <th scope="col">Date</th>
                                <th scope="col">Details</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.warrantyAlertLogs?.map(this.renderAuditLog)}
                        </tbody>
                    </table>

                    <NothingHere loading={this.loading} empty={!this.warrantyAlertLogs?.length} icon={<BsCardHeading />} />
                </div>
            </div>
        );
    }

    public renderAuditLog(auditLog: Mri.Audit.AuditLog<any>, key: any) {
        switch (auditLog.type) {
            case Mri.Audit.ActionType.WarrantyAlertLog:
                const wal = auditLog.payload as Mri.Audit.WarrantyAlertLog;

                return (
                    <tr key={key}>
                        <td scope="row">
                            {wal?.profileGuid && wal.profileGuid !== "00000000-0000-0000-0000-000000000000" &&
                                <a className="btn btn-link"
                                   href={`/display-event-profiles/alerts/${wal.profileGuid}/edit`}>
                                    {wal.profile}
                                </a>
                            }
                            {!wal?.profileGuid || wal.profileGuid == "00000000-0000-0000-0000-000000000000" &&
                                <span>
                                    {wal.profile}
                                </span>
                            }
                        </td>                        <td>{format(auditLog.timestamp, 'Pp z')}</td>
                        <td scope="row">{wal.email}</td>
                    </tr>
                );
            default:
                return (
                    <tr key={key}>
                        <td scope="row">{auditLog.type}</td>
                        <td>{format(auditLog.timestamp, 'Pp z')}</td>
                    </tr>
                );
        }
    }

    @computed
    private get warrantyAlertLogs() {
        const events = this.displaysStore.warrantyAlertLogs.get(this.props.match.params.serialNumber);
        if (events != undefined) {
            return events.sort((a, b) => +new Date(b.timestamp) - +new Date(a.timestamp));
        }
        return events;
    }

    @observable
    private loading = false;
    @inject
    private appStore!: AppStore;
    @inject
    private displaysStore!: DisplaysStore;
}
